import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';
// import CustomBox from '../common/CustomBox';

const getOptions = () => (
  [
    {
      emoji: '⚡️',
      label: 'Quick Book with a Previous Provider',
      value: 'PREVIOUS_PROVIDER',
      description: 'Book with one of your current or past providers.',
    },
    {
      emoji: '📅',
      label: 'Find by Availability',
      value: 'BY_AVAILABILITY',
      description: 'Browse providers with open time slots that match your schedule.',
    },
    {
      emoji: '🔎',
      label: 'Search Our Providers',
      value: 'BROWSE_PROVIDERS',
      description: 'Search by name, specialty, or condition to find the right provider',
    },
  ].map(o => ({
    ...o,
    align: 'flex-start',
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
  }))
);

const PatientWaysToBook = props => {
  const {layout = 'row'} = props;
  return (
    <Stack p={2}>
      <Typography variant='h2'>
        How would you like to search?
      </Typography>
      <Typography mb={2}>
        Choose your preferred booking method
      </Typography>
      <Box style={{width: '100%'}}>
        <ChoiceField
          choiceStyle='card'
          layout={layout}
          options={getOptions()}
          onChange={e => 
            props?.onSubmit
            ? props.onSubmit(e, e.target.value)
            : null
          }
        />
      </Box>
    </Stack>
  );
};

export default PatientWaysToBook;